// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Loader2, X } from "lucide-react";
// import { tvControlData, translations as tvTranslations } from "../data/tvControlData";
// import { useLanguage } from "../language/LanguageContext";

// function UploadedAudiosModal({ isOpen, onClose, emailUser }) {
//   const { language, t } = useLanguage();
//   const [audioDetails, setAudioDetails] = useState([]);
//   const [loading, setLoading] = useState({});
//   const [audioBuffers, setAudioBuffers] = useState({});
//   const [activeAudio, setActiveAudio] = useState(null);
//   const [playing, setPlaying] = useState({});
//   const [filterLanguage, setFilterLanguage] = useState("");
//   const [filterVoiceControl, setFilterVoiceControl] = useState("");
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [zipDownloadUrl, setZipDownloadUrl] = useState("");
//   const [isPreparingZip, setIsPreparingZip] = useState(false);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [isFetchingAudios, setIsFetchingAudios] = useState(false);

//   const ServerUrl = "https://voice-sample.tpvai.com/b/";

//   // Fetch audio details when modal opens
//   useEffect(() => {
//     if (isOpen && emailUser) {
//       fetchAudioDetails();
//     }
//   }, [isOpen, emailUser]);

//   // Reset state when modal closes
//   useEffect(() => {
//     if (!isOpen) {
//       setAudioDetails([]);
//       setFilterLanguage("");
//       setFilterVoiceControl("");
//       setSelectedFiles([]);
//       setZipDownloadUrl("");
//       setIsAllSelected(false);
//       setAudioBuffers({});
//       setActiveAudio(null);
//       setPlaying({});
//     }
//   }, [isOpen]);

//   const fetchAudioDetails = async () => {
//     setIsFetchingAudios(true);
//     try {
//       const response = await axios.get(`${ServerUrl}audios?email=${emailUser}`);
//       if (response.status === 200) {
//         const sortedData = response.data.data.sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate));
//         setAudioDetails(sortedData);
//       } else {
//         throw new Error(t("Failed to fetch audio details"));
//       }
//     } catch (error) {
//       Swal.fire("Error", error.message || t("Failed to fetch audio details"), "error");
//     } finally {
//       setIsFetchingAudios(false);
//     }
//   };

//   const getTranslatedText = (key, type) => {
//     const langKey =
//       language === "en" ? "english" :
//       language === "pt" ? "portuguese" :
//       language === "es" ? "spanish" :
//       language === "es-ar" ? "spanish_ar" :
//       language === "es_mx" ? "spanish_mx" :
//       language === "es-cl" ? "spanish_cl" :
//       language === "es-pe" ? "spanish_pe" :
//       language === "es-BR" ? "spanish_br" :
//       language === "fr" ? "french" :
//       language === "de" ? "german" :
//       language === "it" ? "italian" :
//       language === "zh-TW" ? "chinese_tw" :
//       language === "zh-CN" ? "chinese_cn" :
//       language === "zh-SG" ? "chinese_sg" :
//       language === "nl-BE" ? "dutch_be" :
//       language === "nl-NL" ? "dutch_nl" : "english";
    
//     const translationMap = type === "category" ? tvTranslations.categories : tvTranslations.voiceControls;
//     return translationMap[key]?.[langKey] || translationMap[key]?.["spanish"] || translationMap[key]?.["english"] || key;
//   };

//   const toggleAudio = async (fileName, audioId) => {
//     if (activeAudio && activeAudio.id !== audioId && activeAudio.instance) {
//       activeAudio.instance.pause();
//       activeAudio.instance.currentTime = 0;
//       setPlaying((prev) => ({ ...prev, [activeAudio.id]: false }));
//     }
    
//     if (!audioBuffers[audioId]) {
//       setLoading((prev) => ({ ...prev, [audioId]: true }));
//       try {
//         const response = await axios.post(`${ServerUrl}stream_audio`, { file: fileName }, { responseType: "blob" });
//         const audioBlob = new Blob([response.data], { type: "audio/mpeg" });
//         const audioUrl = URL.createObjectURL(audioBlob);
//         const audio = new Audio(audioUrl);
//         setAudioBuffers((prev) => ({ ...prev, [audioId]: audioUrl }));
//         setActiveAudio({ id: audioId, instance: audio });
//         audio.play();
//         setPlaying((prev) => ({ ...prev, [audioId]: true }));
//       } catch (error) {
//         Swal.fire("Error", t("Failed to load audio: ") + error.message, "error");
//       } finally {
//         setLoading((prev) => ({ ...prev, [audioId]: false }));
//       }
//     } else {
//       const audio = activeAudio?.id === audioId ? activeAudio.instance : new Audio(audioBuffers[audioId]);
//       const isPlaying = playing[audioId];
//       if (isPlaying) {
//         audio.pause();
//         audio.currentTime = 0;
//         setPlaying((prev) => ({ ...prev, [audioId]: false }));
//         setActiveAudio(null);
//       } else {
//         setActiveAudio({ id: audioId, instance: audio });
//         audio.play().catch((err) => console.error("Play error:", err));
//         setPlaying((prev) => ({ ...prev, [audioId]: true }));
//       }
//     }
//   };

//   const handleDownload = async (fileName) => {
//     try {
//       const response = await axios.get(`${ServerUrl}download_audio?file=${encodeURIComponent(fileName)}`, { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", fileName);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       Swal.fire("Error", t("Failed to download audio: ") + error.message, "error");
//     }
//   };

//   const handleFileSelect = (fileName) => {
//     let updatedSelection;
//     if (selectedFiles.includes(fileName)) {
//       updatedSelection = selectedFiles.filter((file) => file !== fileName);
//     } else {
//       updatedSelection = [...selectedFiles, fileName];
//     }
//     setSelectedFiles(updatedSelection);
//     setIsAllSelected(updatedSelection.length === filteredAudioDetails.length);
//   };

//   const handleSelectAll = () => {
//     if (isAllSelected) {
//       setSelectedFiles([]);
//       setIsAllSelected(false);
//     } else {
//       const allFileNames = filteredAudioDetails.map((audio) => audio.fileName);
//       setSelectedFiles(allFileNames);
//       setIsAllSelected(true);
//     }
//   };

//   const prepareZip = async () => {
//     if (selectedFiles.length === 0) {
//       Swal.fire("Warning", t("Please select at least one audio file to download as ZIP."), "warning");
//       return;
//     }
//     setIsPreparingZip(true);
//     try {
//       const response = await axios.post(`${ServerUrl}prepare_audio_zip`, {
//         files: selectedFiles,
//         filterVoiceControl: filterVoiceControl,
//         filterLanguage: filterLanguage,
//       });
//       if (response.status === 200) {
//         setZipDownloadUrl(response.data.downloadUrl);
//         Swal.fire("Success", t("ZIP file prepared successfully!"), "success");
//       }
//     } catch (error) {
//       Swal.fire("Error", error.response?.data?.message || t("Failed to prepare ZIP file"), "error");
//     } finally {
//       setIsPreparingZip(false);
//     }
//   };

//   const handleZipDownload = () => {
//     if (zipDownloadUrl) {
//       const link = document.createElement("a");
//       link.href = zipDownloadUrl;
//       link.setAttribute("download", "");
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       setZipDownloadUrl("");
//       setSelectedFiles([]);
//     }
//   };

//   const languageFilteredAudioDetails = filterLanguage
//     ? audioDetails.filter(audio => audio.audioLanguage === filterLanguage)
//     : audioDetails;

//   const filteredAudioDetails = audioDetails
//     .filter((audio) => {
//       const matchesLanguage = filterLanguage ? audio.audioLanguage === filterLanguage : true;
//       const matchesVoiceControl = filterVoiceControl ? audio.audiotext === filterVoiceControl : true;
//       return matchesLanguage && matchesVoiceControl;
//     })
//     .sort((a, b) => {
//       const langCompare = a.audioLanguage.localeCompare(b.audioLanguage);
//       if (langCompare !== 0) return langCompare;
//       return a.audiotext.localeCompare(b.audiotext);
//     });

//   const uniqueLanguages = [...new Set(audioDetails.map((audio) => audio.audioLanguage))].sort((a, b) =>
//     a.localeCompare(b)
//   );

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" 
//          style={{ margin: 0, padding: '1rem', minHeight: '100vh', minWidth: '100vw' }}>
//       <div className="bg-white rounded-xl shadow-xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
//         {/* Header */}
//         <div className="flex justify-between items-center p-6 border-b border-gray-200">
//           <h2 className="text-2xl font-semibold text-gray-800">{t("Uploaded Audios")}</h2>
//           <button
//             onClick={onClose}
//             className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//           >
//             <X className="w-6 h-6 text-gray-500" />
//           </button>
//         </div>

//         {/* Content */}
//         <div className="flex-1 overflow-y-auto p-6">
//           {isFetchingAudios ? (
//             <div className="flex justify-center items-center h-64">
//               <div className="loader"></div>
//               <span className="ml-2 text-gray-700">{t("Loading audios...")}</span>
//             </div>
//           ) : (
//             <>
//               {/* Filters */}
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
//                 <div>
//                   <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//                     {t("Filter by Language")}
//                   </label>
//                   <select
//                     value={filterLanguage}
//                     onChange={(e) => setFilterLanguage(e.target.value)}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//                   >
//                     <option value="">{t("All Languages")} ({audioDetails.length})</option>
//                     {uniqueLanguages.map((lang) => {
//                       const langCount = audioDetails.filter((audio) => audio.audioLanguage === lang).length;
//                       return (
//                         <option key={lang} value={lang}>
//                           {lang === "english" ? "English" :
//                             lang === "portuguese" ? "Português" :
//                             lang === "spanish" ? "Español" :
//                             lang === "spanish_ar" ? "Español (AR)" :
//                             lang === "spanish_mx" ? "Español (MX)" :
//                             lang === "spanish_cl" ? "Español (CL)" :
//                             lang === "spanish_pe" ? "Español (PE)" :
//                             lang === "spanish_br" ? "Español (BR)" :
//                             lang === "french" ? "Français" :
//                             lang === "german" ? "Deutsch" :
//                             lang === "italian" ? "Italiano" :
//                             lang === "chinese_tw" ? "中文 (繁體, 台灣)" :
//                             lang === "chinese_cn" ? "中文 (简体, 中国)" :
//                             lang === "chinese_sg" ? "中文 (简体, 新加坡)" :
//                             lang === "dutch_be" ? "Nederlands (BE)" :
//                             lang === "dutch_nl" ? "Nederlands (NL)" : lang} ({langCount})
//                         </option>
//                       );
//                     })}
//                   </select>
//                 </div>
//                 <div>
//                   <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
//                     {t("Filter by Voice Control")}
//                   </label>
//                   <select
//                     value={filterVoiceControl}
//                     onChange={(e) => setFilterVoiceControl(e.target.value)}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
//                   >
//                     <option value="">
//                       {t("All Voice Controls")} ({languageFilteredAudioDetails.length})
//                     </option>
//                     {Object.keys(tvControlData).flatMap(category =>
//                       Object.keys(tvControlData[category]).map(control => {
//                         const count = languageFilteredAudioDetails.filter(audio => audio.audiotext === control).length;
//                         return (
//                           <option key={control} value={control}>
//                             {getTranslatedText(control, "voiceControl")} ({count})
//                           </option>
//                         );
//                       })
//                     )}
//                   </select>
//                 </div>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex flex-col sm:flex-row sm:space-x-4 mb-6 items-start sm:items-center gap-4">
//                 <button
//                   onClick={prepareZip}
//                   className={`w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm ${
//                     selectedFiles.length === 0 || isPreparingZip
//                       ? "bg-gray-400 cursor-not-allowed"
//                       : "bg-purple-500 hover:bg-purple-600"
//                   }`}
//                   disabled={selectedFiles.length === 0 || isPreparingZip}
//                 >
//                   {isPreparingZip ? (
//                     <>
//                       <Loader2 className="w-5 h-5 mr-2 inline-block animate-spin" />
//                       {t("Preparing ZIP...")}
//                     </>
//                   ) : (
//                     t("Get ZIP")
//                   )}
//                 </button>

//                 {zipDownloadUrl && (
//                   <button
//                     onClick={handleZipDownload}
//                     className="w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm bg-blue-500 hover:bg-blue-600"
//                   >
//                     {t("Download ZIP")}
//                   </button>
//                 )}

//                 <div className="flex items-center">
//                   <input
//                     type="checkbox"
//                     checked={isAllSelected}
//                     onChange={handleSelectAll}
//                     className="mr-2 h-4 w-4 text-blue-600"
//                   />
//                   <label className="text-sm text-gray-700">{t("Select All")}</label>
//                 </div>
//               </div>

//               {/* Audio List */}
//               <div className="max-h-96 overflow-y-auto border border-gray-200 rounded-lg bg-gray-50 p-4">
//                 {filteredAudioDetails.length > 0 ? (
//                   filteredAudioDetails.map((audio) => (
//                     <div
//                       key={audio._id}
//                       className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-3 mb-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
//                     >
//                       <div className="flex items-center flex-1 mb-2 sm:mb-0 space-y-1">
//                         <input
//                           type="checkbox"
//                           checked={selectedFiles.includes(audio.fileName)}
//                           onChange={() => handleFileSelect(audio.fileName)}
//                           className="mr-2 h-4 w-4 text-blue-600"
//                         />
//                         <div>
//                           <p className="text-xs sm:text-sm text-gray-700">
//                             <strong>{t("Language")}:</strong> {audio.audioLanguage} ({audio.languageCode})
//                           </p>
//                           <p className="text-xs sm:text-sm text-gray-700">
//                             <strong>{t("Voice Control")}:</strong> {getTranslatedText(audio.audiotext, "voiceControl")}
//                           </p>
//                           {audio.audiotext === "Change Channel by Name" && (
//                             <p className="text-xs sm:text-sm text-gray-700">
//                               <strong>{t("Channel Name")}:</strong> {audio.ChannelName || "N/A"}
//                             </p>
//                           )}
//                           {audio.audiotext === "Location-Specific Queries" && (
//                             <p className="text-xs sm:text-sm text-gray-700">
//                               <strong>{t("Country")}:</strong> {audio.Country || "N/A"}
//                             </p>
//                           )}
//                           <p className="text-xs sm:text-sm text-gray-700">
//                             <strong>{t("Gender & Age")}:</strong> {audio.audioLabel}
//                           </p>
//                           <p className="text-xs sm:text-sm text-gray-700 truncate">
//                             <strong>{t("AI Transcribed Text")}:</strong> {audio.transcribedText}
//                           </p>
//                           <p className="text-xs sm:text-sm text-gray-700 truncate">
//                             <strong>{t("User Input Text")}:</strong> {audio.userInput || "N/A"}
//                           </p>
//                           <p className="text-xs sm:text-sm text-gray-700">
//                             <strong>{t("Translated Text")}:</strong> {audio.translation || "N/A"}
//                           </p>
//                           <p className="text-xs sm:text-sm text-gray-700">
//                             <strong>{t("Transcription Status")}:</strong>{" "}
//                             <span className={audio.transcribedStatus === "ok" ? "text-green-600" : "text-red-600"}>
//                               {audio.transcribedStatus === "ok" ? "OK" : "Not OK"}
//                             </span>
//                           </p>
//                           <p className="text-xs sm:text-sm text-gray-700">
//                             <strong>{t("Uploader Email")}:</strong> {audio.uploaderEmail || "N/A"}
//                           </p>
//                           <p className="text-xs sm:text-sm text-gray-700">
//                             <strong>{t("Upload Date")}:</strong> {new Date(audio.uploadDate).toLocaleString()}
//                           </p>
//                           <p className="text-sm text-gray-700 break-all">
//                             <strong>{t("File Name")}:</strong> {audio.fileName}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="flex items-center space-x-2">
//                         {loading[audio._id] ? (
//                           <div className="loader"></div>
//                         ) : (
//                           <button
//                             onClick={() => toggleAudio(audio.fileName, audio._id)}
//                             className={`px-2 py-1 sm:px-3 sm:py-1 rounded text-white text-xs sm:text-sm ${
//                               playing[audio._id] ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
//                             }`}
//                           >
//                             {playing[audio._id] ? t("Stop") : t("Play")}
//                           </button>
//                         )}
//                         <button
//                           onClick={() => handleDownload(audio.fileName)}
//                           className="px-2 py-1 sm:px-3 sm:py-1 rounded bg-blue-500 text-white text-xs sm:text-sm hover:bg-blue-600"
//                         >
//                           {t("Download")}
//                         </button>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <p className="text-sm text-gray-500 text-center py-8">{t("No audio files match the selected filters.")}</p>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UploadedAudiosModal;



// ------------
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Loader2, X, Trash2 } from "lucide-react";
import { iotControlData as tvControlData, translations as tvTranslations } from "../data/NewControlData";
import { useLanguage } from "../language/LanguageContext";
import { ServerUrl } from "../config";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import UtteranceTrackerModal from "./UtteranceTrackerModal";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function UploadedAudiosModal({ isOpen, onClose, emailUser }) {
  const { language, t } = useLanguage();
  const userRole = localStorage.getItem("role") || "user";
  const isSuper = userRole === "superadmin";
  const isAdmin = userRole === "admin";
  const [audioDetails, setAudioDetails] = useState([]);
  const [loading, setLoading] = useState({});
  const [audioBuffers, setAudioBuffers] = useState({});
  const [activeAudio, setActiveAudio] = useState(null);
  const [playing, setPlaying] = useState({});
  const [filterLanguage, setFilterLanguage] = useState("");
  const [filterVoiceControl, setFilterVoiceControl] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [zipDownloadUrl, setZipDownloadUrl] = useState("");
  const [isPreparingZip, setIsPreparingZip] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isFetchingAudios, setIsFetchingAudios] = useState(false);
  const [showChart, setShowChart] = useState(false);
  const [isTrackerOpen, setIsTrackerOpen] = useState(false);

  useEffect(() => {
    if (isOpen && emailUser) {
      fetchAudioDetails();
    }
  }, [isOpen, emailUser]);

  useEffect(() => {
    if (!isOpen) {
      setAudioDetails([]);
      setFilterLanguage("");
      setFilterVoiceControl("");
      setSelectedFiles([]);
      setZipDownloadUrl("");
      setIsAllSelected(false);
      setAudioBuffers({});
      setActiveAudio(null);
      setPlaying({});
      setShowChart(false);
    }
  }, [isOpen]);

  const fetchAudioDetails = async () => {
    setIsFetchingAudios(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${ServerUrl}audios`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.status === 200) {
        const sortedData = response.data.data.sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate));
        setAudioDetails(sortedData);
      } else {
        throw new Error(t("Failed to fetch audio details"));
      }
    } catch (error) {
      // Handle 404 silently for "No audio files found" - just set empty state
      if (error.response?.status === 404) {
        setAudioDetails([]);
      } else {
        Swal.fire("Error", error.message || t("Failed to fetch audio details"), "error");
      }
    } finally {
      setIsFetchingAudios(false);
    }
  };

  const getTranslatedText = (key, type) => {
    const langKey =
      language === "en" ? "english" :
      language === "nl" ? "dutch" :
      language === "fr" ? "french" :
      language === "de" ? "german" :
      language === "it" ? "italian" :
      language === "es" ? "spanish" : "english";

    const translationMap = type === "category" ? tvTranslations.categories : tvTranslations.voiceControls;
    return translationMap[key]?.[langKey] || translationMap[key]?.["spanish"] || translationMap[key]?.["english"] || key;
  };

  const toggleAudio = async (fileName, audioId) => {
    if (activeAudio && activeAudio.id !== audioId && activeAudio.instance) {
      activeAudio.instance.pause();
      activeAudio.instance.currentTime = 0;
      setPlaying((prev) => ({ ...prev, [activeAudio.id]: false }));
    }

    if (!audioBuffers[audioId]) {
      setLoading((prev) => ({ ...prev, [audioId]: true }));
      try {
        const response = await axios.post(
          `${ServerUrl}stream_audio`,
          { file: fileName },
          { responseType: "blob" }
        );
        const audioBlob = new Blob([response.data], { type: "audio/mpeg" });
        const audioUrl = URL.createObjectURL(audioBlob);
        const audio = new Audio(audioUrl);
        setAudioBuffers((prev) => ({ ...prev, [audioId]: audioUrl }));
        setActiveAudio({ id: audioId, instance: audio });
        audio.play();
        setPlaying((prev) => ({ ...prev, [audioId]: true }));
      } catch (error) {
        Swal.fire("Error", t("Failed to load audio: ") + error.message, "error");
      } finally {
        setLoading((prev) => ({ ...prev, [audioId]: false }));
      }
    } else {
      const audio = activeAudio?.id === audioId ? activeAudio.instance : new Audio(audioBuffers[audioId]);
      const isPlaying = playing[audioId];
      if (isPlaying) {
        audio.pause();
        audio.currentTime = 0;
        setPlaying((prev) => ({ ...prev, [audioId]: false }));
        setActiveAudio(null);
      } else {
        setActiveAudio({ id: audioId, instance: audio });
        audio.play().catch((err) => console.error("Play error:", err));
        setPlaying((prev) => ({ ...prev, [audioId]: true }));
      }
    }
  };

  const handleDownload = async (fileName) => {
    try {
      const response = await axios.get(`${ServerUrl}download_audio?file=${encodeURIComponent(fileName)}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      Swal.fire("Error", t("Failed to download audio: ") + error.message, "error");
    }
  };

  const handleDeleteAudio = async (audioId) => {
    const result = await Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel")
    });

    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.delete(`${ServerUrl}delete_audio/${audioId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.status === 200) {
          Swal.fire(t("Deleted!"), t("The audio sample has been deleted."), "success");
          fetchAudioDetails();
        }
      } catch (error) {
        console.error("Failed to delete audio:", error);
        Swal.fire("Error", error.response?.data?.message || error.message || t("Failed to delete audio"), "error");
      }
    }
  };

  const handleFileSelect = (fileName) => {
    let updatedSelection;
    if (selectedFiles.includes(fileName)) {
      updatedSelection = selectedFiles.filter((file) => file !== fileName);
    } else {
      updatedSelection = [...selectedFiles, fileName];
    }
    setSelectedFiles(updatedSelection);
    setIsAllSelected(updatedSelection.length === filteredAudioDetails.length);
  };

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedFiles([]);
      setIsAllSelected(false);
    } else {
      const allFileNames = filteredAudioDetails.map((audio) => audio.fileName);
      setSelectedFiles(allFileNames);
      setIsAllSelected(true);
    }
  };

  const prepareZip = async () => {
    if (selectedFiles.length === 0) {
      Swal.fire("Warning", t("Please select at least one audio file to download as ZIP."), "warning");
      return;
    }
    setIsPreparingZip(true);
    try {
      const response = await axios.post(`${ServerUrl}prepare_audio_zip`, {
        files: selectedFiles,
        filterVoiceControl: filterVoiceControl,
        filterLanguage: filterLanguage,
      });
      if (response.status === 200) {
        setZipDownloadUrl(response.data.downloadUrl);
        Swal.fire("Success", t("ZIP file prepared successfully!"), "success");
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || t("Failed to prepare ZIP file"), "error");
    } finally {
      setIsPreparingZip(false);
    }
  };

  const handleZipDownload = () => {
    if (zipDownloadUrl) {
      const link = document.createElement("a");
      link.href = zipDownloadUrl;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setZipDownloadUrl("");
      setSelectedFiles([]);
    }
  };

  const filteredAudioDetails = audioDetails
    .filter((audio) => {
      const matchesLanguage = filterLanguage ? audio.audioLanguage === filterLanguage : true;
      const matchesVoiceControl = filterVoiceControl ? audio.audiotext === filterVoiceControl : true;
      return matchesLanguage && matchesVoiceControl;
    })
    .sort((a, b) => {
      const langCompare = a.audioLanguage.localeCompare(b.audioLanguage);
      if (langCompare !== 0) return langCompare;
      return a.audiotext.localeCompare(b.audiotext);
    });

  const uniqueLanguages = [...new Set(audioDetails.map((audio) => audio.audioLanguage))].sort((a, b) =>
    a.localeCompare(b)
  );

  const getChartData = () => {
    const filteredByLanguage = filterLanguage
      ? audioDetails.filter((audio) => audio.audioLanguage === filterLanguage)
      : audioDetails;

    let voiceControlsToCount = [];

    if (filterVoiceControl) {
      voiceControlsToCount = [filterVoiceControl];
    } else {
      voiceControlsToCount = [...new Set(filteredByLanguage.map((audio) => audio.audiotext))];
    }

    const countsMap = {};
    voiceControlsToCount.forEach((vc) => {
      countsMap[vc] = filteredByLanguage.filter((audio) => audio.audiotext === vc).length;
    });

    const labels = voiceControlsToCount.map((vc) => getTranslatedText(vc, "voiceControl"));
    const data = voiceControlsToCount.map((vc) => countsMap[vc] || 0);

    return {
      labels,
      datasets: [
        {
          label: t("Audio Count"),
          data,
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
        },
      ],
    };
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false, // Allow chart to fit container height
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: t("Audio Counts by Voice Control") },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
    },
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      style={{ margin: 0, padding: "1rem" }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          console.log("Overlay clicked, closing modal");
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-xl shadow-xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex justify-between items-center p-6 border-b border-gray-200 z-10">
          <h2 className="text-2xl font-semibold text-gray-800">{t("Uploaded Audios")}</h2>
          <button
            onClick={() => {
              console.log("Close button clicked");
              onClose();
            }}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6 text-gray-500" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6" style={{ maxHeight: "calc(90vh - 80px)" }}>
          {isFetchingAudios ? (
            <div className="flex justify-center items-center h-64">
              <div className="loader"></div>
              <span className="ml-2 text-gray-700">{t("Loading audios...")}</span>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                    {t("Filter by Language")}
                  </label>
                  <select
                    value={filterLanguage}
                    onChange={(e) => setFilterLanguage(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
                  >
                    <option value="">{t("All Languages")} ({audioDetails.length})</option>
                    {uniqueLanguages.map((lang) => {
                      const langCount = audioDetails.filter((audio) => audio.audioLanguage === lang).length;
                      return (
                        <option key={lang} value={lang}>
                          {lang === "english"
                            ? "English"
                            : lang === "dutch"
                            ? "Nederlands"
                            : lang === "french"
                            ? "Français"
                            : lang === "german"
                            ? "Deutsch"
                            : lang === "italian"
                            ? "Italiano"
                            : lang === "spanish"
                            ? "Español"
                            : lang}{" "}
                          ({langCount})
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div>
                  <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                    {t("Filter by Voice Control")}
                  </label>
                  <select
                    value={filterVoiceControl}
                    onChange={(e) => setFilterVoiceControl(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-xs sm:text-sm"
                  >
                    <option value="">
                      {t("All Voice Controls")} ({filterLanguage ? filteredAudioDetails.length : audioDetails.length})
                    </option>
                    {Object.keys(tvControlData).flatMap((category) =>
                      Object.keys(tvControlData[category]).map((control) => {
                        const count = (filterLanguage ? filteredAudioDetails : audioDetails).filter(
                          (audio) => audio.audiotext === control
                        ).length;
                        return (
                          <option key={control} value={control}>
                            {getTranslatedText(control, "voiceControl")} ({count})
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>
              </div>

              {isSuper && (
                <div className="flex items-center mb-6">
                  <input
                    id="toggleChart"
                    type="checkbox"
                    className="mr-2 h-4 w-4 text-blue-600"
                    checked={showChart}
                    onChange={() => setShowChart(!showChart)}
                  />
                  <label htmlFor="toggleChart" className="text-sm text-gray-700 cursor-pointer">
                    {t("Show Bar Chart")}
                  </label>
                </div>
              )}

              {showChart && isSuper ? (
                <div className="max-w-full overflow-x-auto">
                  <div style={{ width: "100%", height: "400px" }}>
                    <Bar data={getChartData()} options={chartOptions} />
                  </div>
                </div>
              ) : (
                <>
                  <div className="flex flex-col sm:flex-row sm:space-x-4 mb-6 items-start sm:items-center gap-4">
                    {(isAdmin || isSuper) && (
                      <button
                        onClick={() => setIsTrackerOpen(true)}
                        className="w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm bg-indigo-600 hover:bg-indigo-700 font-semibold"
                      >
                        📊 Track Pending Utterances
                      </button>
                    )}
                    {isSuper && (
                      <>
                        <button
                          onClick={prepareZip}
                          className={`w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm ${
                            selectedFiles.length === 0 || isPreparingZip
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-purple-500 hover:bg-purple-600"
                          }`}
                          disabled={selectedFiles.length === 0 || isPreparingZip}
                        >
                          {isPreparingZip ? (
                            <>
                              <Loader2 className="w-5 h-5 mr-2 inline-block animate-spin" />
                              {t("Preparing ZIP...")}
                            </>
                          ) : (
                            t("Get ZIP")
                          )}
                        </button>

                        {zipDownloadUrl && (
                          <button
                            onClick={handleZipDownload}
                            className="w-full sm:w-auto px-4 py-2 rounded text-white text-xs sm:text-sm bg-blue-500 hover:bg-blue-600"
                          >
                            {t("Download ZIP")}
                          </button>
                        )}

                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                            className="mr-2 h-4 w-4 text-blue-600"
                          />
                          <label className="text-sm text-gray-700">{t("Select All")}</label>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="max-h-96 overflow-y-auto border border-gray-200 rounded-lg bg-gray-50 p-4">
                    {filteredAudioDetails.length > 0 ? (
                      filteredAudioDetails.map((audio) => (
                        <div
                          key={audio._id}
                          className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-3 mb-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
                        >
                          <div className="flex items-center flex-1 mb-2 sm:mb-0 space-y-1">
                            {isSuper && (
                              <input
                                type="checkbox"
                                checked={selectedFiles.includes(audio.fileName)}
                                onChange={() => handleFileSelect(audio.fileName)}
                                className="mr-2 h-4 w-4 text-blue-600"
                              />
                            )}
                            <div>
                              <p className="text-xs sm:text-sm text-gray-700">
                                <strong>{t("Language")}:</strong> {audio.audioLanguage} ({audio.languageCode})
                              </p>
                              <p className="text-xs sm:text-sm text-gray-700">
                                <strong>{t("Voice Control")}:</strong> {getTranslatedText(audio.audiotext, "voiceControl")}
                              </p>
                              {audio.audiotext === "Change Channel by Name" && (
                                <p className="text-xs sm:text-sm text-gray-700">
                                  <strong>{t("Channel Name")}:</strong> {audio.ChannelName || "N/A"}
                                </p>
                              )}
                              {audio.audiotext === "Location-Specific Queries" && (
                                <p className="text-xs sm:text-sm text-gray-700">
                                  <strong>{t("Country")}:</strong> {audio.Country || "N/A"}
                                </p>
                              )}
                              <p className="text-xs sm:text-sm text-gray-700">
                                <strong>{t("Gender & Age")}:</strong> {audio.audioLabel}
                              </p>
                              <p className="text-xs sm:text-sm text-gray-700 truncate">
                                <strong>{t("AI Transcribed Text")}:</strong> {audio.transcribedText}
                              </p>
                              <p className="text-xs sm:text-sm text-gray-700 truncate">
                                <strong>{t("User Input Text")}:</strong> {audio.userInput || "N/A"}
                              </p>
                              <p className="text-xs sm:text-sm text-gray-700">
                                <strong>{t("Translated Text")}:</strong> {audio.translation || "N/A"}
                              </p>

                              <p className="text-xs sm:text-sm text-gray-700">
                                <strong>{t("Uploader Email")}:</strong> {audio.uploaderEmail || "N/A"}
                              </p>
                              <p className="text-xs sm:text-sm text-gray-700">
                                <strong>{t("Upload Date")}:</strong> {new Date(audio.uploadDate).toLocaleString()}
                              </p>
                              <p className="text-sm text-gray-700 break-all">
                                <strong>{t("File Name")}:</strong> {audio.fileName}
                              </p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-2">
                            {loading[audio._id] ? (
                              <div className="loader"></div>
                            ) : (
                              <button
                                onClick={() => toggleAudio(audio.fileName, audio._id)}
                                className={`px-2 py-1 sm:px-3 sm:py-1 rounded text-white text-xs sm:text-sm ${
                                  playing[audio._id] ? "bg-red-500 hover:bg-red-600" : "bg-green-500 hover:bg-green-600"
                                }`}
                              >
                                {playing[audio._id] ? t("Stop") : t("Play")}
                              </button>
                            )}
                            <button
                              onClick={() => handleDeleteAudio(audio._id)}
                              className="px-2 py-1 sm:px-3 sm:py-1 rounded bg-red-500 hover:bg-red-600 text-white text-xs sm:text-sm transition-colors flex items-center gap-1 font-medium"
                              title={t("Delete Audio")}
                            >
                              <Trash2 className="w-3.5 h-3.5" />
                              <span>{t("Delete")}</span>
                            </button>
                            {(isAdmin || isSuper) && (
                              <button
                                onClick={() => handleDownload(audio.fileName)}
                                className="px-2 py-1 sm:px-3 sm:py-1 rounded bg-blue-500 text-white text-xs sm:text-sm hover:bg-blue-600"
                              >
                                {t("Download")}
                              </button>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-sm text-gray-500 text-center py-8">{t("No audio files match the selected filters.")}</p>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>

      <UtteranceTrackerModal
        isOpen={isTrackerOpen}
        onClose={() => setIsTrackerOpen(false)}
        initialLanguage={filterLanguage}
      />
    </div>
  );
}

export default UploadedAudiosModal;